// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  TDesktopDeleteAllNotificationsModel,
  IMappers,
  TDesktopDeleteAllNotificationsResponse,
  TDesktopDeleteAllNotificationsResponse_1,
  TDesktopDeleteAllNotificationsResponseError,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';

export const defaultConfig: TDesktopDeleteAllNotificationsModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'notification-center',
  pathApi: '/v1/desktop/delete-all-notifications/',
} as TDesktopDeleteAllNotificationsModel;

export function createDesktopDeleteAllNotificationsModel(): TDesktopDeleteAllNotificationsModel {
  return {
    ...defaultConfig,
  };
}

export interface IDesktopDeleteAllNotificationsOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

export async function fetchDesktopDeleteAllNotifications<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
}: IDesktopDeleteAllNotificationsOptions<TResponse200, TResponse400>): Promise<
  TDesktopDeleteAllNotificationsResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(createDesktopDeleteAllNotificationsModel(), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TDesktopDeleteAllNotificationsResponse_1);
    }
    if (statusCode === 400) {
      return mappers[400](response as TDesktopDeleteAllNotificationsResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TDesktopDeleteAllNotificationsResponse;
}
